import { Grid } from '@mui/material';
import { memo } from 'react';

import {
  convertCalculationStrategy,
  convertReportMode,
  convertStatus,
  convertStatusUrl,
} from '../../../api/enumerations';
import { AssociationWOData } from '../../../api/registryAssociation/types';
import { formatOnlyDate, formatReal } from '../../../helpers';
import { InputTitle } from '../../UI/Typography';
import { Constants } from './constants';
import {
  AssociatedCard,
  ItemStatus,
  OSLink,
  SmallStyledInput,
  StatusGrid,
} from './styles';

interface AssociatedItemProps {
  associatedData: AssociationWOData;
}

const AssociatedItem = memo(({ associatedData }: AssociatedItemProps) => {
  const navigateToWorkOrder = (): string => {
    const status = convertStatusUrl(associatedData.status);
    return `/home/property/${associatedData.id}/${status}`;
  };
  return (
    <AssociatedCard container rowGap={1}>
      <StatusGrid item>
        <OSLink to={navigateToWorkOrder()} target="blank">
          OS-{associatedData.reference_number}
        </OSLink>
        <ItemStatus>{convertStatus(associatedData.status)}</ItemStatus>
      </StatusGrid>
      <Grid item container>
        <Grid item xs={3}>
          <InputTitle>{Constants.createdAt}</InputTitle>
          <SmallStyledInput>
            {formatOnlyDate(associatedData.created_at)}
          </SmallStyledInput>
        </Grid>
        <Grid item xs={3}>
          <InputTitle>{Constants.evaluatedValue}</InputTitle>
          <SmallStyledInput>
            {formatReal(associatedData.evaluated_value)}
          </SmallStyledInput>
        </Grid>
        <Grid item xs={3}>
          <InputTitle>{Constants.evaluationType}</InputTitle>
          <SmallStyledInput>
            {convertCalculationStrategy(associatedData.calculation_strategy)}
          </SmallStyledInput>
        </Grid>
        <Grid item xs={3}>
          <InputTitle>{Constants.reportType}</InputTitle>
          <SmallStyledInput>
            {convertReportMode(associatedData.report_mode)}
          </SmallStyledInput>
        </Grid>
      </Grid>
    </AssociatedCard>
  );
});

export default AssociatedItem;
